import React, { forwardRef } from 'react';
import { InputFrame } from './input-frame.js';
import { InputWithAnalytics } from './input-with-analytics.js';

const InputNumber = forwardRef(
  ({
    className,
    disabled,
    invalid,
    label,
    onChange,
    onClear,
    optional,
    prefix,
    size = "md",
    suffix,
    tooltip,
    value,
    ...rest
  }, ref) => /* @__PURE__ */ React.createElement(InputFrame, {
    className,
    disabled,
    hasValue: !!value,
    invalid,
    label,
    onClear,
    optional,
    prefix,
    size,
    suffix,
    tooltip
  }, /* @__PURE__ */ React.createElement(InputWithAnalytics, {
    ...rest,
    disabled,
    label,
    onChange,
    ref,
    type: "number",
    value: value != null ? value : ""
  }))
);
InputNumber.displayName = "Input.Number";

export { InputNumber };
//# sourceMappingURL=input-number.js.map
